import { render, staticRenderFns } from "./CostSendMain.vue?vue&type=template&id=1c52f9ed&scoped=true"
import script from "./CostSendMain.vue?vue&type=script&lang=js"
export * from "./CostSendMain.vue?vue&type=script&lang=js"
import style0 from "./CostSendMain.vue?vue&type=style&index=0&id=1c52f9ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52f9ed",
  null
  
)

export default component.exports